import { designTokens } from './helpers';

const screens = {
  xs: '320px',
  s: '480px',
  m: '768px',
  l: '976px',
  xl: '1280px',
  xxl: '1440px',
};

const zIndices = {
  deep: '-999999',
  default: '1',
  masked: '100',
  mask: '200',
  sticky: '300',
  header: '400',
  dropdown: '600',
  overlay: '700',
  drawer: '800',
  spinner: '900',
  modal: '1000',
  loading: '1100',
  popup: '1200',
  tooltip: '1300',
  toast: '1405',
};

const headingFontSizes = {
  xxs: '1.25rem',
  xs: '1.5rem',
  s: '2rem',
  m: '2.5rem',
  l: '3rem',
  xl: '3.5rem',
  '2xl': '4.5rem',
  '3xl': '4.75rem',
  '4xl': '6rem',
};

const {
  borderWidths,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  media,
  radii,
  shadows,
  sizes,
  space,
} = designTokens;

const iconSizes = {
  xs: sizes[3],
  s: sizes[4],
  m: sizes[6],
  l: sizes[8],
  xl: sizes[16],
};

export const theme = {
  borderWidths,
  colors: {
    action: {
      nonInteractive: {
        emphasis: colors.nonInteractiveEmphasis,
      },
      conversion: {
        static: colors.actionConversionStatic,
        highlight: colors.actionConversionHighlight,
        disabled: colors.actionConversionDisabled,
      },
      success: {
        static: colors.actionSuccessStatic,
        highlight: colors.actionSuccessHighlight,
        disabled: colors.actionSuccessDisabled,
      },
      alert: {
        static: colors.actionAlertStatic,
        highlight: colors.actionAlertHighlight,
        disabled: colors.actionAlertDisabled,
      },
      navigation: {
        standard: {
          static: colors.actionNavigationStandardStatic,
          highlight: colors.actionNavigationStandardHighlight,
          disabled: colors.actionNavigationStandardDisabled,
        },
        alt: {
          static: colors.actionNavigationAltStatic,
          highlight: colors.actionNavigationAltHighlight,
          disabled: colors.actionNavigationAltDisabled,
        },
        warning: {
          static: colors.actionNavigationWarningStatic,
          highlight: colors.actionNavigationWarningHighlight,
          disabled: colors.actionNavigationWarningDisabled,
        },
      },
    },
    assorted: {
      '1': colors[1],
      '2': colors[2],
      '3': colors[3],
      '4': colors[4],
      '5': colors[5],
      '6': colors[6],
      '7': colors[7],
      '8': colors[8],
      '9': colors[9],
      '10': colors[10],
      '11': colors[11],
      '12': colors[12],
    },
    build: {
      brand1: colors['brand-1'],
      brand2: colors['brand-2'],
      brand3: colors['brand-3'],
      darkDark: colors['dark-dark'],
      darkLight: colors['dark-light'],
      lightLight: colors['light-light'],
      lightDark1: colors['light-dark-1'],
      lightDark2: colors['light-dark-2'],
      mediumLight1: colors['medium-light-1'],
      mediumLight2: colors['medium-light-2'],
      mediumMedium: colors['medium-medium'],
    },
    disabled: {
      standard: colors.disabled,
      dark: colors.disabledDark,
    },
    gradient: {
      '1': colors['gradient-1'],
      '2': colors['gradient-2'],
      '3': colors['gradient-3'],
      '4': colors['gradient-4'],
    },
    status: {
      alert: {
        standard: colors['alert-standard'],
        alt: colors['alert-alt'],
      },
      error: {
        standard: colors['error-standard'],
        alt: colors['error-alt'],
      },
      success: {
        standard: colors['success-standard'],
        alt: colors['success-alt'],
      },
    },
    shadow: {
      light: colors.shadowLight,
      dark: colors.shadowDark,
    },
    background: {
      standard: colors.background,
    },
    overlay: {
      standard: colors.overlay,
    },
    support: {
      facebook: colors.facebook,
      whatsapp: colors.whatsapp,
    },
  },
  fontSizes,
  fontWeights,
  fonts,
  headingFontSizes,
  iconSizes,
  letterSpacings,
  lineHeights,
  media,
  radii,
  screens,
  shadows: {
    down: {
      close: shadows.downClose,
      far: shadows.downFar,
      mid: shadows.downMid,
      soft: shadows.downSoft,
    },
    up: {
      soft: shadows.upSoft,
      mid: shadows.upMid,
    },
    right: {
      mid: shadows.rightMid,
    },
    left: {
      mid: shadows.leftMid,
    },
    outline: {
      standard: shadows.outline,
    },
  },
  sizes,
  space,
  zIndices,
} as const;

export type Theme = typeof theme;
